import React from 'react'
import { View } from 'react-native'
import { useAppSelector } from 'hooks/redux'
import BoxInvestment from 'components/molecules/BoxInvestment'
import InfoSVG from 'assets/svg/infoSVG'
import styles from './style'
import useNavigation from 'hooks/useNavigation'
import { useDispatch } from 'react-redux'
import { setShowInvestmentInfo } from 'store/modals/actions'
import { InvestmentActionType, InvestmentStatus } from '../types'

const BoxBalanceInvestments: React.FC = () => {
  const { balance } = useAppSelector(state => state.transfers)
  const {
    lastPerformance,
    balanceHoldingAccount,
    isBalanceHoldingError,
    investmentClient,
    tutorialCompleted,
    authorization
  } = useAppSelector(store => store.investments)
  const { onNavigate } = useNavigation()
  const dispatch = useDispatch()
  const disabledAction =
    !tutorialCompleted || !authorization || investmentClient?.statusId !== InvestmentStatus.APPROVED
  const noBalance = Number(balance) === 0
  const noBalanceHoldingAccount = Number(balanceHoldingAccount) === 0

  const handleInfoClick = () => {
    dispatch(setShowInvestmentInfo(true))
  }

  return (
    <View style={styles.viewBoxBalanceContainer}>
      <View style={styles.viewBoxContainer}>
        <BoxInvestment
          title="Dinero disponible"
          amount={balance}
          width="450px"
          height="165px"
          action={InvestmentActionType.INVEST}
          disabledAction={disabledAction || noBalance}
          onPressButton={() =>
            onNavigate('investment-operation', {
              title: 'Suscripciones',
              hasBackArrow: true
            })}
          showEyeButton
        />
        <BoxInvestment
          title="Dinero invertido"
          lastPerformance={lastPerformance}
          amount={balanceHoldingAccount}
          balanceHoldingError={isBalanceHoldingError}
          width="450px"
          height="165px"
          action={InvestmentActionType.RESCUE}
          disabledAction={disabledAction || noBalanceHoldingAccount}
          onPressButton={() =>
            onNavigate('investment-operation', {
              title: 'Rescates',
              hasBackArrow: true
            })}
          showEyeButton
        />

        <div
          style={{
            position: 'absolute',
            bottom: -35,
            right: 0,
            cursor: 'pointer'
          }}
          onClick={handleInfoClick}
        >
          <InfoSVG />
        </div>
      </View>
    </View>
  )
}

export default BoxBalanceInvestments
